import React from 'react';

const Demosi = () => {
  return (
    <h1>Demosi</h1>
  );
};

export default Demosi;





